import { render, staticRenderFns } from "./liveSetting.vue?vue&type=template&id=616bad0d&scoped=true"
import script from "./liveSetting.vue?vue&type=script&lang=js"
export * from "./liveSetting.vue?vue&type=script&lang=js"
import style0 from "./liveSetting.vue?vue&type=style&index=0&id=616bad0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616bad0d",
  null
  
)

export default component.exports